import React from 'react';

const KovFooterLeftSection = ({
  logoSection = {
    href: 'https://pro.katholiekonderwijs.vlaanderen/',
    imageSrc: '../../assets/img/logo_ko_vl.png',
  },
  children,
}) => {
  return (
    <div className="footer-logo">
      <a
        data-testid="logo-link"
        className="footerbar-icon"
        href={logoSection.href}
        target="_blank"
        rel="noreferrer"
      >
        <img src={logoSection.imageSrc} alt="Logo" />
      </a>
      {children}
    </div>
  );
};

export default KovFooterLeftSection;
